import React, { FC } from 'react';
import { TableRow as MuiTableRow } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';

import { CELL_HEIGHT } from 'features/activity/constants';

const styles = () =>
  createStyles({
    head: {
      height: 48,
      borderLeft: 0,
      borderRight: 0,
    },
    body: {
      height: CELL_HEIGHT,
    },
  });

const RowHead: FC<WithStyles<typeof styles>> = ({ classes, children }) => (
  <MuiTableRow classes={{ head: classes.head }}>{children}</MuiTableRow>
);

const RowBody: FC<WithStyles<typeof styles>> = ({ classes, children }) => (
  <MuiTableRow classes={{ root: classes.body }}>{children}</MuiTableRow>
);

const EnhancedRowHead = withStyles(styles)(RowHead);
const EnhancedRowBody = withStyles(styles)(RowBody);

export { EnhancedRowHead as RowHead, EnhancedRowBody as RowBody };
